import React from 'react';
import { Typography } from '@mui/material';

const NoAuthFields = ({ t }) => {
  return (
    <Typography variant="body2" color="textSecondary">
      {t('NO_AUTH')}
    </Typography>
  );
};

export default NoAuthFields;


